var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiselectBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Block_18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 10,
    height: 10,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    fill: "none",
    stroke: "#0032c5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 4.75,
    height: 1.5,
    rx: 0.75,
    transform: "translate(2.625 4.202)",
    fill: "#0032c5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselectBlockIcon);
export default __webpack_public_path__ + "static/media/MultiselectBlock-icon.42e27fd9cb71e20fb63f6ca77d7b6387.svg";
export { ForwardRef as ReactComponent };